
import Component, { mixins } from "vue-class-component"
import Calculator from "../mixins/Calculator.vue"
import ArtikelRow from "../custom/ArtikelRow.vue"
import moment from "moment"
import { AnforderungStatus, Bezahlart } from "@/entities/common/enums"
import FilialeHeader from "../custom/FilialeHeader.vue"
import Serviceanforderung from "@/entities/common/serviceanforderung"
import DetailsSofortLogic from "@/logic/bestellung/details_sofort_logic"
import NachbestellungSheet from "../custom/NachbestellungSheet.vue"

@Component({ components: { ArtikelRow, FilialeHeader, NachbestellungSheet } })
export default class DetailsSofort extends mixins(Calculator) {
  logic: DetailsSofortLogic = new DetailsSofortLogic()

  berechneGesamtpreis(): number {
    return this.logic.berechneGesamtpreis()
  }

  serviceAbsenden() {
    this.logic.serviceAbsenden()
  }

  berechneGesamtpreisTrinkgeld(): number {
    return this.logic.berechneGesamtpreisTrinkgeld()
  }

  formatiereBoolean(value: boolean) {
    return value ? "ja" : "nein"
  }

  formatiereBezahlart(value: string) {
    switch (value) {
      case Bezahlart.BARZAHLUNG:
        return "Zahlung an der Kasse"
      case Bezahlart.PAYPAL:
        return "PayPal"
    }
  }

  mounted() {
    this.logic = new DetailsSofortLogic()
    this.logic.init()
  }

  computeDauer(value: string): string {
    if (value == null) return null
    return moment(value).format("HH:mm")
  }

  computeStatusIcon(service: Serviceanforderung): string {
    if (service.status == AnforderungStatus.OFFEN) {
      return "mdi-timer-sand-empty"
    }
  }

  formatiereServiceStatus(value: string): string {
    switch (value) {
      case AnforderungStatus.OFFEN:
        return "offen"
      case AnforderungStatus.ANGENOMMEN:
        return "angenommen"
      case AnforderungStatus.ABGELEHNT:
        return "abgelehnt"
      case AnforderungStatus.ERLEDIGT:
        return "erledigt"
    }
  }

  serviceAnfordern() {
    this.logic.serviceAnfordern()
  }

  serviceanforderungErstellen() {
    console.log("serviceanforderung erstellen")
    this.logic.serviceanforderungErstellen()
  }

  nachbestellen() {
    this.logic.nachbestellen()
  }

  bezahlen() {
    this.logic.bezahlen()
  }
}
